import { z } from "zod";

export const abuseReasonDto = z.object({
  id: z.number(),
  text: z.string(),
});

export const abuseAppointmentDto = z.object({
  appointmentId: z.number(),
  startDateTime: z.coerce.date(),
  endDateTime: z.coerce.date(),
});

export const siteSupportAbuseDtoSchema = z.object({
  abuses: z.array(abuseReasonDto),
  appointments: z.array(abuseAppointmentDto),
});

export type TSiteSupportAbuseDto = z.infer<typeof siteSupportAbuseDtoSchema>;
export type TSiteSupportAbuseAppointmentDto = z.infer<typeof abuseAppointmentDto>;
export type TSiteSupportAbuseReasonDto = z.infer<typeof abuseReasonDto>;
